import uuid from 'uuid';
import User from 'helper/currentUser';
import { CommandTypeEnum } from 'appConsts/CommandTypeEnum';
import { ActorTypeEnum } from 'appConsts/ActorTypeEnum';

const user = new User();
const timeStamp = new Date().toISOString();

function formatReviews(reviews) {
  return reviews.map(review => ({
    modifiedOn: timeStamp,
    rating: review.rating,
    responseText: review.responseText,
    responseType: review.responseType,
    toReviewQuestionId: review.questionId
  }));
}

function createFieldsForCommand() {
  return {
    id: uuid(),
    creatorId: user.id(),
    type: CommandTypeEnum.PEER_REVIEW,
    actorType: ActorTypeEnum.USER
  };
}

// Also getting used in admin popup
export default function formatData(commandProperties, isCommnad = false, isAnonymous = true) {
  const {
    offerId,
    receiverId,
    reviewedSubmissionId,
    reviews,
    contentId,
    correspondingQuestionId,
    companyId
  } = commandProperties;
  const commnadFields = isCommnad && createFieldsForCommand();
  return {
    ...commnadFields,
    timeStamp,
    rootContentId: offerId,
    contentId,
    isAnonymous,
    receiverId,
    reviewedAssignmentQuestionId: correspondingQuestionId,
    reviewedSubmissionId,
    reviewerId: user.id(),
    reviews: formatReviews(reviews),
    companyId
  };
}
